// src/lib/Toast.ts

type ToastOptions = {
  durationMs?: number;
  position?: "bottom-right" | "top-center";
};

type ToastType = "success" | "error" | "warning" | "info";

const TOAST_CONFIG: Record<
  ToastType,
  {
    accentColor: string;
    iconBackgroundColor: string;
    icon: string;
    title: string;
  }
> = {
  success: {
    accentColor: "#07625C",
    iconBackgroundColor: "#ecfdf5",
    icon: "✅",
    title: "Success",
  },
  warning: {
    accentColor: "#d97706",
    iconBackgroundColor: "#fffbeb",
    icon: "⚠️",
    title: "Warning",
  },
  error: {
    accentColor: "#dc2626",
    iconBackgroundColor: "#fef2f2",
    icon: "❌",
    title: "Error",
  },
  info: {
    accentColor: "#2563eb",
    iconBackgroundColor: "#eff6ff",
    icon: "ℹ️",
    title: "Information",
  },
};

export const showToast = (
  message: string,
  type: ToastType = "success",
  options: ToastOptions = {}
) => {
  const existingToast = document.querySelector(".custom-toast-container");
  if (existingToast) existingToast.remove();

  const toast = document.createElement("div");
  toast.className = "custom-toast-container";

  const { durationMs = 10000, position = "bottom-right" } = options;

  const { accentColor, iconBackgroundColor, icon, title } = TOAST_CONFIG[type];

  const positionStyles =
    position === "top-center"
      ? {
          top: "24px",
          left: "50%",
          transform: "translateX(-50%)",
        }
      : {
          bottom: "40px",
          right: "40px",
        };

  Object.assign(toast.style, {
    position: "fixed",
    backgroundColor: "#ffffff",
    color: "#1f2937",
    padding: "12px 20px",
    borderRadius: "12px",
    boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
    zIndex: "99999",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "350px",
    borderLeft: `6px solid ${accentColor}`,
    transition: "all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    fontFamily: "'Inter', sans-serif",
    border: "1px solid #f3f4f6",
    ...positionStyles,
  });

  toast.innerHTML = `
    <div style="display:flex;align-items:center;gap:15px;">
      <div
        style="
          background:${iconBackgroundColor};
          padding:8px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
        "
      >
        <span style="font-size:18px">${icon}</span>
      </div>

      <div style="display:flex;flex-direction:column;">
        <span
          style="
            font-size:14px;
            font-weight:600;
            color:#111827;
          "
        >
          ${title}
        </span>

        <span
          style="
            font-size:13px;
            color:#6b7280;
            margin-top:2px;
          "
        >
          ${message}
        </span>
      </div>
    </div>

    <button
      id="close-toast-btn"
      style="
        background:none;
        border:none;
        color:#9ca3af;
        cursor:pointer;
        font-size:18px;
        width:32px;
        height:32px;
        border-radius:8px;
        display:flex;
        align-items:center;
        justify-content:center;
      "
    >
      ✕
    </button>
  `;

  document.body.appendChild(toast);

  const removeToast = () => {
    toast.style.opacity = "0";
    toast.style.transform =
      position === "top-center" ? "translate(-50%, -12px)" : "translateX(50px)";

    setTimeout(() => toast.remove(), 500);
  };

  const btn = toast.querySelector("#close-toast-btn") as HTMLElement;

  if (btn) {
    btn.onclick = (e) => {
      e.stopPropagation();
      removeToast();
    };

    btn.onmouseenter = () => {
      btn.style.backgroundColor = "#f3f4f6";
      btn.style.color = "#111827";
    };

    btn.onmouseleave = () => {
      btn.style.backgroundColor = "transparent";
      btn.style.color = "#9ca3af";
    };
  }

  setTimeout(() => {
    if (document.body.contains(toast)) {
      removeToast();
    }
  }, durationMs);
};
